import { useOidc } from '@/features/oidc/oidc'
import {
  TrackingProvider,
  initializeTrackingSdk,
} from '@vgw/multibrand-fe-tracking'
import { ReactNode, useMemo } from 'react'

interface TrackingProps {
  apiKey: string
  children: ReactNode
}

export const Tracking = ({ apiKey, children }: TrackingProps) => {
  const { decodedIdToken, isUserLoggedIn } = useOidc()

  const trackingSdk = useMemo(
    () =>
      initializeTrackingSdk({
        apiKey,
        isUserLoggedIn,
        pamAccountId: decodedIdToken?.['pam-aid'] as string,
      }),
    [apiKey, isUserLoggedIn, decodedIdToken],
  )

  return (
    <TrackingProvider amplitudeInstance={trackingSdk}>
      {children}
    </TrackingProvider>
  )
}
